import { render } from "./SiteIndex.vue?vue&type=template&id=4789e6cc&ts=true"
import script from "./SiteIndex.vue?vue&type=script&lang=ts"
export * from "./SiteIndex.vue?vue&type=script&lang=ts"

import "./SiteIndex.vue?vue&type=style&index=0&id=4789e6cc&lang=scss"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__